import { useMemo, useRef } from 'react'
import { useIntl } from 'react-intl'
import { HOTEL_SEARCH_TYPEAHEAD_TYPES, searchVerticalItemsByKey } from 'constants/search'
import { useGlobalHotelsSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHotelsSearch'
import HotelsTabContent from '../Components/Mobile/TabContents/HotelsTabContent'
import useGlobalSearchVerticalTabBooking from './useGlobalSearchVerticalTabBooking'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import useQueryParams from 'hooks/useQueryParams'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import { OptimizelyExperiments } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'

function useGlobalSearchVerticalTabHotels(): App.GlobalSearchVerticalTabV2 {
  const queryParams = useQueryParams()
  const {
    globalHotelsSearchDispatch,
    globalHotelsSearchState,
  } = useGlobalHotelsSearchContext(GLOBAL_SEARCH_INITIAL_STATE, queryParams)

  const naturalLanguageSearch = !!useOptimizelyExperiment(OptimizelyExperiments.searchNaturalLanguageSearch)

  // Temporary: Ref to expose typeaheadId and searchPhrase for search submission
  const temporarySearchSubmitRef = useRef<App.TypeaheadSubmitRefData | null>(null)

  const {
    onSearch,
    context,
    updateSearchSessionId,
  } = useGlobalSearchVerticalTabBooking({
    globalSearchDispatch: globalHotelsSearchDispatch,
    globalSearchState: globalHotelsSearchState,
    temporarySearchSubmitRef,
    naturalLanguageSearch,
    typeaheadTypes: HOTEL_SEARCH_TYPEAHEAD_TYPES,
  })

  const intl = useIntl()

  return useMemo((): App.GlobalSearchVerticalTabV2 => {
    return {
      label: searchVerticalItemsByKey.get('hotels')?.label ?? intl.formatMessage({
        id: 'lPfwmpLasc',
        defaultMessage: 'hotels and resorts',
        description: 'Fallback label for hotels search vertical tab',
      }),
      key: 'hotels',
      context,
      onSearch,
      ContentComponent: HotelsTabContent,
      Icon: LineBedIcon,
      updateSearchSessionId,
      temporarySearchSubmitRef,
    }
  }, [context, onSearch, updateSearchSessionId, temporarySearchSubmitRef, intl])
}

export default useGlobalSearchVerticalTabHotels
